import { render, staticRenderFns } from "./mydt.vue?vue&type=template&id=bb905868&scoped=true&"
import script from "./mydt.vue?vue&type=script&lang=js&"
export * from "./mydt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb905868",
  null
  
)

export default component.exports